'use client';

import type { MyCurationItem } from '@musinsa/services-curator';
import { TitleSection } from '../../common/components/TitleSection';
import { MyShopGoodItems } from './MyShopGoodItems';
import { MyShopSnapItems } from './MyShopSnapItems';

interface Props {
  item: MyCurationItem;
  pageCache: Map<string, number>;
  setPageCache: React.Dispatch<React.SetStateAction<Map<string, number>>>;
  curationIndex: number;
}

export const MyShopCurationItem = ({ item, pageCache, setPageCache, curationIndex }: Props) => {
  const isSnapCuration = item.type === 'SNAP2';

  return (
    <div className="flex flex-col">
      <TitleSection curationIndex={curationIndex} item={item} useMoreButton />
      {isSnapCuration ? (
        <MyShopSnapItems
          curationId={item.curationId}
          curationIndex={curationIndex}
          items={item.snapItems}
          pageCache={pageCache}
          setPageCache={setPageCache}
          title={item.title}
        />
      ) : (
        <MyShopGoodItems
          curationId={item.curationId}
          curationIndex={curationIndex}
          items={item.goodsItems}
          pageCache={pageCache}
          setPageCache={setPageCache}
          title={item.title}
        />
      )}
    </div>
  );
};
